// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__c9Duc","inner":"Form_inner__1CmyF","range":"Form_range__2nC7m","name":"Form_name__346eJ","actions":"Form_actions__sFXOb"};